import { FC } from 'react';
import styled from 'styled-components';

import { useDownloadAppModal } from '@hooks/useDownloadAppModal';
import { useShowDataById } from '@redux/selectors/shows';
import { useScreenSizes } from '@hooks/useScreenSizes';

import ChannelView from './components/ChannelView';
import LogoButton from './components/LogoButton';
import ParticipantsButton from './components/ParticipantsButton';
import ExitButton from './components/ExitButton';

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 4px 8px;
`;

const MenuContainer = styled.div`
  min-width: 30%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 8%;
`;

type Props = {
  showId: string;
  exitButtonText?: string;
  onExitShow: () => void;
};

const Menu: FC<Props> = ({ showId, exitButtonText = 'Exit', onExitShow }) => {
  const show = useShowDataById(showId);
  const { openDownloadAppModal } = useDownloadAppModal();
  const { isMobile, isTablet } = useScreenSizes();

  return (
    <Container>
      <MenuContainer>
        {!!show?.channelId && <ChannelView channelId={show.channelId} />}

        {isMobile || isTablet ? null : (
          <ParticipantsButton count={show?.listenersCount} disabled />
        )}
      </MenuContainer>

      {isMobile || isTablet ? null : (
        <LogoButton text='Join Now' onClick={() => openDownloadAppModal()} />
      )}

      <ExitButton text={exitButtonText} onExitShow={onExitShow} />
    </Container>
  );
};

export default Menu;
